export default "__VITE_ASSET__12c763c5__"